import * as React from 'react';
import styled from 'styled-components';
import { themeGet } from 'styled-system';
import { ThemeInterface } from '../../theme/ThemeInterface';
import { theme } from '../../theme';

interface RadioButtonProps {}

const InputWrap = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  padding: 20px;
  position: relative;
  border-radius: 4px;
  align-items: center;
  margin-bottom: 10px;
  margin-right: 20px;
  box-sizing: border-box;
  justify-content: center;
  border: 1px solid ${themeGet('colors.paleGrey', '#eee')};
  & input[type='radio'] {
    position: absolute;
    visibility: hidden;
  }
  & input[type='radio']:checked ~ .check {
    border: 2px solid ${themeGet('colors.putty', '#eee')};
    background: ${themeGet('colors.putty', '#eee')};
  }
  & input[type='radio']:checked ~ label {
    color: ${themeGet('colors.putty', '#eee')};
    border: 1px solid ${themeGet('colors.putty', '#eee')};
  }
  & .check {
    z-index: ${theme.zIndex[3]};
    left: 20px;
    width: 15px;
    height: 15px;
    display: block;
    position: absolute;
    border-radius: 4px;
    transition: border 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    border: 2px solid ${themeGet('colors.transparentBlack', '#eee')};
  }
  &:hover label {
    color: ${themeGet('colors.putty', '#eee')};
  }
  &:hover .check {
    border: 2px solid ${themeGet('colors.putty', '#eee')};
  }
  @media screen and (max-width: 1024px) {
    flex: 1 0 47%;
    margin-right: 20px;
  }
  @media screen and (max-width: 768px) {
    flex: 1 0 100%;
    margin-right: 0;
  }
`;

const RadioLabel = styled.label`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: ${theme.zIndex[5]};
  display: flex;
  cursor: pointer;
  border-radius: 4px;
  position: absolute;
  align-items: center;
  font-weight: normal;
  justify-content: center;
  text-transform: uppercase;
  transition: all 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  font-size: ${(props: ThemeInterface) => props.theme.fontSizes[2]};
`;

const RadioButton: React.FunctionComponent<RadioButtonProps> = (props: any) => {
  return (
    <InputWrap>
      <input
        name={props.field.name}
        id={props.id}
        type="radio"
        value={props.id} // could be something else for output?
        checked={props.id === props.field.value}
        onChange={props.field.onChange}
        onBlur={props.field.onBlur}
        {...props}
      />
      <RadioLabel htmlFor={props.id}>{props.label}</RadioLabel>
      <div className="check" />
    </InputWrap>
  );
};

export default RadioButton;



// WEBPACK FOOTER //
// ./src/components/formElements/StyledRadioButton.tsx